<div class="grid">
  <div class="md:col-6 col-12">
    <p-card
      header="Описание"
      styleClass="mt-3">
      <div class="p-fluid">
        <div class="field">
          <label class="font-medium required-field">Название</label>
          <crm-input-text
            [(value)]="data.name"
            [isError]="$any(errors?.name)"></crm-input-text>
          <small
            *ngIf="errors?.name"
            class="p-error">
            {{ errors.name | join }}
          </small>
        </div>

        <div class="field">
          <label class="font-medium required-field">Тема письма</label>
          <crm-input-text
            [(value)]="data.title"
            [isError]="$any(errors?.title)"></crm-input-text>
          <small
            *ngIf="errors?.title"
            class="p-error">
            {{ errors.title | join }}
          </small>
        </div>

        <div class="field">
          <label class="font-medium required-field">Текст сообщения</label>
          <crm-editor
            [(value)]="data.text"
            height="250px"></crm-editor>
          <small
            *ngIf="errors?.text"
            class="p-error">
            {{ errors.text | join }}
          </small>
        </div>

        <div class="formgrid grid">
          <div class="field lg:col-6 col-12">
            <label class="font-medium required-field">Тип</label>
            <crm-single-select
              [options]="types"
              [(selectedItem)]="data.type"
              class="w-full {{ errors?.type ? 'ng-invalid ng-dirty' : '' }}"
              dataKey="name"
              [styleClass]="errors?.type ? 'ng-invalid ng-dirty' : ''"
              [isTemplateCombined]="true"
              [filter]="false"
              appendTo="body">
              <ng-template
                #itemTemplate
                let-type="item">
                {{ type.value | mailingTypeName }}
              </ng-template>
            </crm-single-select>
            <small
              *ngIf="errors?.type"
              class="p-error">
              {{ errors.type | join }}
            </small>
          </div>

          <div class="field lg:col-6 col-12">
            <label class="font-medium required-field">Канал</label>
            <crm-single-select
              [options]="channels"
              [(selectedItem)]="data.channel"
              (selectedItemChange)="changeChannel($event)"
              class="w-full {{ errors?.channel ? 'ng-invalid ng-dirty' : '' }}"
              dataKey="name"
              [styleClass]="errors?.channel ? 'ng-invalid ng-dirty' : ''"
              [isTemplateCombined]="true"
              [filter]="false"
              appendTo="body">
              <ng-template
                #itemTemplate
                let-type="item">
                {{ type.value | mailingChannelName }}
              </ng-template>
            </crm-single-select>
            <small
              *ngIf="errors?.channel"
              class="p-error">
              {{ errors.channel | join }}
            </small>
          </div>

          <div
            *ngIf="data.channel === MailingChannelEnum.SMS"
            class="field lg:col-6 col-12">
            <label class="font-medium required-field">SMS сервис</label>
            <crm-newsletter-sms-sender-single-select
              [(smsSender)]="data.smsSender"
              [arraySms]="arraySms"
              [isError]="$any(errors?.smsSender)"
              [showClear]="true"></crm-newsletter-sms-sender-single-select>
            <small
              *ngIf="errors?.smsSender"
              class="p-error">
              {{ errors.smsSender | join }}
            </small>
          </div>

          <ng-container *ngIf="data.channel === MailingChannelEnum.EMAIL">
            <div class="field lg:col-6 col-12">
              <label class="font-medium required-field">Тип почтового сервиса</label>
              <p-selectButton
                [options]="emailOptions"
                [(ngModel)]="data.emailSender.gate"
                (ngModelChange)="changeEmailType($event)">
              </p-selectButton>
            </div>

            <div
              *ngIf="data.emailSender.gate === EmailGateEnum.FRM"
              class="field lg:col-6 col-12">
              <label class="font-medium required-field">Email сервис</label>
              <crm-newsletter-email-sender-single-select
                [(email)]="data.emailSender.email"
                [emails]="emails"
                [isError]="$any(errors?.emailSender)"
                [showClear]="true"></crm-newsletter-email-sender-single-select>
              <small
                *ngIf="errors?.emailSender"
                class="p-error">
                {{ errors.emailSender | join }}
              </small>
            </div>

            <ng-container *ngIf="data.emailSender.gate === EmailGateEnum.MAIN_SMS">
              <div class="field lg:col-6 col-12">
                <label class="font-medium required-field">MainSMS сервис</label>
                <crm-newsletter-email-main-sms-sender-single-select
                  [(email)]="data.emailSender.mainSmsAccount"
                  (emailChange)="changeEmailMainSms($event)"
                  [emails]="arraySms"
                  [isError]="$any(errors?.emailSender)"
                  [showClear]="true"></crm-newsletter-email-main-sms-sender-single-select>
                <small
                  *ngIf="errors?.emailSender"
                  class="p-error">
                  {{ errors.emailSender | join }}
                </small>
              </div>

              <div
                *ngIf="data.emailSender.mainSmsAccount"
                class="field lg:col-6 col-12">
                <label class="font-medium required-field">Email</label>
                <crm-single-select
                  [options]="data.emailSender.mainSmsAccount.emails"
                  [(selectedItem)]="data.emailSender.mainSmsAccountEmail"
                  class="w-full {{ errors?.emailSender ? 'ng-invalid ng-dirty' : '' }}"
                  dataKey="name"
                  [styleClass]="errors?.emailSender ? 'ng-invalid ng-dirty' : ''"
                  [filter]="false"
                  [showClear]="true"
                  appendTo="body">
                </crm-single-select>
                <small
                  *ngIf="errors?.emailSender"
                  class="p-error">
                  {{ errors.emailSender | join }}
                </small>
              </div>
            </ng-container>
          </ng-container>

          <ng-container *ngIf="data.type === MailingTypeEnum.BILLS">
            <div class="field lg:col-6 col-12">
              <label class="font-medium required-field">Период</label>
              <crm-daterangepicker
                [value]="[data.attachmentStartDate, data.attachmentEndDate]"
                (changeValue)="setBillingPeriod($event)"
                appendTo="body"></crm-daterangepicker>
              <small
                *ngIf="errors?.attachmentStartDate"
                class="p-error">
                {{ errors?.attachmentStartDate | join }}
              </small>
              <small
                *ngIf="errors?.attachmentEndDate"
                class="p-error">
                {{ errors?.attachmentEndDate | join }}
              </small>
            </div>

            <div class="field lg:col-6 col-12">
              <label class="font-medium">Бюджетная статья</label>
              <crm-direction-multi-select
                [directions]="directions"
                [(selectedDirections)]="data.billingDirections"
                [styleClass]="errors?.billingDirections ? 'ng-invalid ng-dirty' : ''"
                [class]="errors?.billingDirections ? 'ng-invalid ng-dirty' : ''"
                placeholder=""
                appendTo="body"></crm-direction-multi-select>
              <small
                *ngIf="errors?.billingDirections"
                class="p-error">
                {{ errors?.billingDirections | join }}
              </small>
            </div>

            <div class="field lg:col-6 col-12">
              <label class="font-medium">Статус</label>
              <crm-multi-select
                [options]="billingPaymentStatuses"
                [(selectedItems)]="data.billingPaymentStatuses"
                class="w-full {{ errors?.billingPaymentStatuses ? 'ng-invalid ng-dirty' : '' }}"
                dataKey="name"
                [styleClass]="errors?.billingPaymentStatuses ? 'ng-invalid ng-dirty' : ''"
                [showHeader]="false"
                display="comma"
                appendTo="body">
                <ng-template
                  #selectedItemsTemplate
                  let-bills="items">
                  <ng-container *ngFor="let bill of bills; last as isLast">
                    {{ bill?.value | billPaymentStatusName }}{{ isLast ? '' : ', ' }}
                  </ng-container>
                </ng-template>
                <ng-template
                  #itemTemplate
                  let-bill="item">
                  {{ bill.value | billPaymentStatusName }}
                </ng-template>
              </crm-multi-select>
              <small
                *ngIf="errors?.billingPaymentStatuses"
                class="p-error">
                {{ errors.billingPaymentStatuses | join }}
              </small>
            </div>

            <div class="field lg:col-6 col-12">
              <label class="font-medium">Состояние</label>
              <crm-multi-select
                [options]="attachmentStatuses"
                [(selectedItems)]="data.attachmentStatuses"
                dataKey="name"
                display="comma"
                [styleClass]="errors?.attachmentStatuses ? 'ng-invalid ng-dirty' : ''"
                class="w-full {{ errors?.attachmentStatuses ? 'ng-invalid ng-dirty' : '' }}"
                [showHeader]="false"
                appendTo="body">
                <ng-template
                  #selectedItemsTemplate
                  let-statuses="items">
                  <ng-container *ngFor="let status of statuses; last as isLast">
                    {{ status?.value | mailingAttachmentStatusName }}{{ isLast ? '' : ', ' }}
                  </ng-container>
                </ng-template>
                <ng-template
                  #itemTemplate
                  let-status="item">
                  {{ status.value | mailingAttachmentStatusName }}
                </ng-template>
              </crm-multi-select>
              <small
                *ngIf="errors?.attachmentStatuses"
                class="p-error">
                {{ errors.attachmentStatuses | join }}
              </small>
            </div>
          </ng-container>

          <ng-container *ngIf="data.type === MailingTypeEnum.DEBTORS || data.type === MailingTypeEnum.BILLS">
            <div class="field lg:col-6 col-12">
              <label
                class="font-medium"
                [class.required-field]="data.type === MailingTypeEnum.DEBTORS">
                Компания
              </label>
              <crm-multi-select
                [options]="companies"
                [(selectedItems)]="data.companies"
                [virtualScroll]="true"
                [virtualScrollItemSize]="33"
                [class]="errors?.companies ? 'ng-invalid ng-dirty' : ''"
                [styleClass]="errors?.companies ? 'ng-invalid ng-dirty' : ''"
                appendTo="body"></crm-multi-select>
              <small
                *ngIf="errors?.companies"
                class="p-error">
                {{ errors.companies | join }}
              </small>
            </div>

            <div class="field lg:col-6 col-12">
              <label class="font-medium">Контрагент</label>
              <crm-contragent-multi-select
                [contragents]="contragents"
                [(selectedContragents)]="data.contragents"
                [isError]="$any(errors?.contragents)"
                [customSearch]="true"
                appendTo="body"></crm-contragent-multi-select>
              <small
                *ngIf="errors?.contragents"
                class="p-error">
                {{ errors.contragents | join }}
              </small>
            </div>
          </ng-container>
        </div>

        <div
          *ngIf="data.type === MailingTypeEnum.DEBTORS_FROM_FILE"
          class="field">
          <label class="font-medium required-field">Файл</label>
          <crm-file-uploader
            [isUploadFiles]="false"
            [uploadingFiles]="loadingFile"
            (filesSelected)="selectedFileDebtor($event)"
            label="Файл"></crm-file-uploader>
          <small
            *ngIf="errors?.fileDebtorTargets"
            class="p-error">
            {{ errors.fileDebtorTargets | join }}
          </small>
        </div>

        <div
          *ngIf="[MailingTypeEnum.DEBTORS_FROM_FILE, MailingTypeEnum.DEBTORS].includes($any(data.type))"
          class="field-checkbox">
          <p-checkbox
            [(ngModel)]="data.includingAdvancePayment"
            [binary]="true"
            inputId="includingAdvancePayment"></p-checkbox>
          <label [for]="'includingAdvancePayment'">С учетом аванс</label>
        </div>

        <div
          *ngIf="data.type === MailingTypeEnum.DEBTORS && data.channel === MailingChannelEnum.EMAIL"
          class="field-checkbox">
          <p-checkbox
            [(ngModel)]="data.attachBills"
            [binary]="true"
            inputId="attachBills"></p-checkbox>
          <label [for]="'attachBills'">Отправлять счета</label>
        </div>
      </div>
    </p-card>

    <div
      *ngIf="data.type === MailingTypeEnum.BILLS && (!canDelete || (canDelete && data.bills?.length))"
      class="mt-3">
      <p-card header="Счета">
        <div class="flex align-items-center gap-3">
          <button
            *ngIf="!canDelete"
            pButton
            label="Поиск счетов"
            icon="pi pi-search"
            [loading]="loadingBills"
            [disabled]="!data.attachmentStartDate || !data.attachmentEndDate"
            (click)="findBills()"></button>

          <button
            *ngIf="bills?.length && !loadingBills && !canDelete"
            pButton
            [label]="bills?.length === data.bills?.length ? 'Убрать все' : 'Выбрать все'"
            class="p-button-text"
            (click)="toggleAllSelectedBill()"></button>
        </div>

        <crm-table
          *ngIf="bills?.length && !loadingBills && !canDelete"
          [columns]="billColumns"
          [values]="bills"
          scrollHeight="300px"
          styleClass="mt-3">
          <ng-template
            #rowTemplate
            let-bill="item">
            <tr *ngIf="toBill(bill) as bill">
              <td>
                <div class="flex align-items-center gap-3">
                  <div class="field-checkbox mb-0">
                    <p-checkbox
                      [ngModel]="!!(data.bills | findByKey: 'erp1cRef':bill.erp1cRef)"
                      (ngModelChange)="toggleSelectedBill(bill)"
                      [binary]="true"
                      (click)="$event.stopPropagation()"></p-checkbox>
                  </div>
                  <div>{{ bill.erp1cNumber }}</div>
                </div>
              </td>
              <td>
                <a
                  *ngIf="bill.contragent"
                  routerLink="/client/contragent/card/{{ bill.contragent?.id }}"
                  target="_blank">
                  {{ bill.contragent?.name }}
                </a>
              </td>
              <td>
                {{ bill.directions | join: 'name' }}
              </td>
              <td>
                {{ bill.amount | number: '.0-0' }}
              </td>
              <td>
                {{ bill.lastSentViaMailing ? 'Отправлен' : 'Не отправлен' }}
              </td>
            </tr>
          </ng-template>
        </crm-table>

        <crm-table
          *ngIf="canDelete"
          [columns]="billColumns"
          [values]="data.bills"
          scrollHeight="300px">
          <ng-template
            #rowTemplate
            let-bill="item">
            <tr *ngIf="toBill(bill) as bill">
              <td>
                {{ bill.erp1cNumber }}
              </td>
              <td>
                <a
                  *ngIf="bill.contragent"
                  routerLink="/client/contragent/card/{{ bill.contragent?.id }}"
                  target="_blank">
                  {{ bill.contragent?.name }}
                </a>
              </td>
              <td>
                {{ bill.directions | join: 'name' }}
              </td>
              <td>
                {{ bill.amount | number: '.0-0' }}
              </td>
              <td>
                {{ bill.lastSentViaMailing ? 'Отправлен' : 'Не отправлен' }}
              </td>
            </tr>
          </ng-template>
        </crm-table>
      </p-card>
    </div>

    <div class="mt-3">
      <p-card header="Планирование">
        <div class="field lg:col-6 col-12">
          <label class="font-medium required-field">Дата и время создания</label>
          <crm-datepicker
            [(value)]="data.date"
            [showTime]="true"
            styleClass="w-full"
            [inputStyleClass]="errors?.date ? 'ng-invalid ng-dirty' : ''"
            appendTo="body"></crm-datepicker>
          <small
            *ngIf="errors?.date"
            class="p-error">
            {{ errors.date | join }}
          </small>
        </div>
      </p-card>
    </div>
  </div>

  <div class="md:col-6 col-12">
    <p-card
      header="Аудиторы"
      styleClass="md:mt-3">
      <div class="formgrid grid">
        <div class="field lg:col-6 col-12">
          <label class="font-medium">Пользователи</label>
          <crm-user-multi-select
            [(selectedUsers)]="data.userAuditors"
            [isError]="$any(errors?.userAuditors)"
            [isFloatLabel]="false"
            appendTo="body"></crm-user-multi-select>
          <p
            *ngIf="errors?.userAuditors"
            class="p-error">
            {{ errors.userAuditors | join }}
          </p>
        </div>
        <div class="field lg:col-6 col-12">
          <label class="font-medium">Группы</label>
          <crm-multi-select
            [(selectedItems)]="data.groupAuditors"
            [options]="userGroups"
            [class]="errors?.groupAuditors ? 'ng-invalid ng-dirty' : ''"
            [styleClass]="errors?.groupAuditors ? 'ng-invalid ng-dirty' : ''"
            appendTo="body">
          </crm-multi-select>
          <p
            *ngIf="errors?.groupAuditors"
            class="p-error">
            {{ errors.groupAuditors | join }}
          </p>
        </div>
      </div>
    </p-card>

    <p-card
      *ngIf="data.type === MailingTypeEnum.HELPDESK"
      header="Участники рассылки"
      styleClass="md:mt-3">
      <div class="formgrid grid">
        <div class="field lg:col-6 col-12">
          <label class="font-medium required-field">Внешние пользователи</label>
          <crm-multi-select
            [(selectedItems)]="data.externalUsers"
            [options]="externalUsers"
            [class]="errors?.externalUsers ? 'ng-invalid ng-dirty' : ''"
            [showToggleAll]="true"
            optionLabel="profile.name"
            [styleClass]="errors?.externalUsers ? 'ng-invalid ng-dirty' : ''"
            appendTo="body"></crm-multi-select>
          <p
            *ngIf="errors?.externalUsers"
            class="p-error">
            {{ errors.externalUsers | join }}
          </p>
        </div>
        <div class="field lg:col-6 col-12">
          <label class="font-medium">Пользователи</label>
          <crm-user-multi-select
            [users]="recipientUsers"
            [(selectedUsers)]="data.recipientUsers"
            [isError]="$any(errors?.recipientUsers)"
            [customRequest]="true"
            [isFloatLabel]="false"
            appendTo="body"></crm-user-multi-select>
          <p
            *ngIf="errors?.recipientUsers"
            class="p-error">
            {{ errors.recipientUsers | join }}
          </p>
        </div>
      </div>
    </p-card>

    <p-card
      *ngIf="data.type === MailingTypeEnum.DEBTORS_FROM_FILE"
      header="Участники рассылки"
      styleClass="mt-3">
      <div *ngIf="errors?.fileDebtorTargets">
        <small class="p-error">
          {{ $any(errors.fileDebtorTargets) | joinWithChild }}
        </small>
      </div>

      <p
        *ngIf="!data.fileDebtorTargets?.length"
        class="text-xl font-bold">
        Список участников пустой
      </p>

      <crm-table
        *ngIf="data.fileDebtorTargets?.length"
        name="newsletter.form.contacts"
        [columns]="columns"
        [values]="data.fileDebtorTargets"
        [scrollable]="true"
        scrollHeight="300px"
        styleClass="p-datatable-sm sticky-header">
        <ng-template
          #rowTemplate
          let-target="item">
          <tr *ngIf="toItemContactFromFile(target) as target">
            <td [ngStyle]="{ 'min-width.px': 140 }">
              {{ target?.name }}
            </td>
            <td [ngStyle]="{ 'min-width.px': 140 }">
              <div>
                <ng-container *ngIf="data.channel === MailingChannelEnum.EMAIL">
                  <div *ngIf="target?.email; else notEmail">
                    <a href="mailto:{{ target?.email }}">{{ target?.email }}</a>
                  </div>
                  <ng-template #notEmail><p class="text-gray-400">Нет email</p></ng-template>
                </ng-container>
                <ng-container *ngIf="data.channel === MailingChannelEnum.SMS">
                  <div *ngIf="target.phone; else notPhone">
                    <a href="tel:{{ target?.phone }}">{{ target?.phone | phone }}</a>
                  </div>
                  <ng-template #notPhone><p class="text-gray-400">Нет телефона</p></ng-template>
                </ng-container>
              </div>
            </td>
            <td [ngStyle]="{ 'min-width.px': 100, 'max-width.px': 100 }">
              {{ target.amount | number: '.0-0' }}
            </td>
            <td [ngStyle]="{ 'max-width.px': 35, 'min-width.px': 35 }">
              <i
                class="pi pi-times cursor-pointer hover:text-red-300 text-red-500"
                style="font-size: 1.5rem"
                (click)="deleteContragentFromFile(target)"></i>
            </td>
          </tr>
        </ng-template>
      </crm-table>
    </p-card>

    <crm-newsletter-history-widget
      *ngIf="canDelete"
      [newsletterId]="getNewsletterId"
      class="block mt-3"></crm-newsletter-history-widget>
  </div>
</div>

<div class="grid mt-3">
  <div class="md:col-6 col-12 flex flex-wrap justify-content-between">
    <div>
      <button
        pButton
        [label]="saveButtonLabel"
        class="p-button-success mr-2"
        (click)="onSave(data)"></button>
      <crm-go-back-button
        *ngIf="!isModal"
        [route]="route"></crm-go-back-button>
    </div>
    <button
      *ngIf="canDelete"
      pButton
      label="Удалить"
      class="p-button-danger p-button-text"
      (click)="delete.emit(data)"></button>
  </div>
</div>
